<template>
    <div>
        <div
            class="review-widget-wrapper"
        >
            <h2>
                Thanks for saving your details
            </h2>
            <Notice
                id="tuo-confirm-success-message"
                header="Personal information is saved."
                notice-type="SUCCESS"
            />
            <PiSecure/>
            <p>
                To review and manage your personal information, log in to your MyServiceNSW account.
            </p>
            <Button
                id="tuo-goto-myservicensw-button"
                secondary
                @click="goToMyServiceNSW"
            >
                Log in to account
            </Button>
        </div>
    </div>
</template>

<script>
    import PiSecure from "../components/PiSecure"
    import Notice from "../components/Notice"
    import Button from "../components/Button"

    export default {
        name: "SaveSusses",
        components: {Notice, PiSecure, Button},
        methods: {
            goToMyServiceNSW() {
                window.open(process.env.VUE_APP_MYACCOUNT_DASHBOARD_URL)
            }
        }
    }
</script>
<style lang="css" src="../../node_modules/@servicensw/constants/constants.css"></style>
<style lang="css" scoped src="../../node_modules/@servicensw/base/dist/base.css"></style>
<style scoped>
    .review-widget-wrapper {
        background: #f9f9f9;
        padding: 0 20px 25px 20px;
        margin-bottom: 30px;
        border-bottom: 1px solid silver;
        border-top: 1px solid silver;
    }
    h2 {
        margin-top: 2rem;
    }
</style>
